const DEFAULT_PRICING_PERIOD = 'annual';
const PRICING_PERIOD_EVENT = 'wombat:pricing-period-change';

/**
 * Normalize the requested pricing period.
 *
 * @param {string} period Raw pricing period.
 * @return {string} Normalized pricing period.
 */
const normalizePricingPeriod = ( period ) => period === 'monthly' ? 'monthly' : DEFAULT_PRICING_PERIOD;

/**
 * Read the current global pricing period.
 *
 * @return {string} Current pricing period.
 */
const getPricingPeriod = () => normalizePricingPeriod( window.wombat?.pricingPeriod );

/**
 * Update visible pricing row inside a price block.
 *
 * @param {HTMLElement} block Price block element.
 * @param {string} period Active pricing period.
 * @return {void}
 */
const updatePriceVisibility = ( block, period ) => {

	const rows = block.querySelectorAll( '[data-price-period]' );
	rows.forEach( ( row ) => {

		row.hidden = row.dataset.pricePeriod !== period;

	} );

};

document.querySelectorAll( '.b-price' ).forEach( ( block ) => {

	if ( block.dataset.priceVisibilityReady === 'true' ) {

		return;

	}

	updatePriceVisibility( block, getPricingPeriod() );
	window.addEventListener( PRICING_PERIOD_EVENT, ( event ) => {

		updatePriceVisibility( block, normalizePricingPeriod( event.detail?.period ) );

	} );
	block.dataset.priceVisibilityReady = 'true';

} );
